export const shadows = {
  sm: { value: "0 2px 10px 0 rgba(0,0,0,0.05)" },
  md: { value: "0 4px 6px -1px rgba(0,0,0,0.1)" },
  lg: { value: "0 4px 6px -1px rgba(0,0,0,0.25)" },
};
